import { Constant } from "app/shared/constant/constant";
import i18n from "app/shared/language/i18n";
import { TRANSPROFILE } from "app/shared/services/services-model.type";
import { nonAccentVietnamese } from "app/shared/util/validate";

export const TYPE_CHOOSE_BENE = {
  ACCOUNT: "ACCOUNT",
  BENE: "BENE",
};

export interface PROFILE_BENE {
  NAME?: string;
  AVATAR?: string;
  PROFILE_ID?: string;
  BEN_NAME?: string;
  ACCOUNT_NUMBER?: string;
  BANK_NAME?: string; // 247
  REGION_NAME?: string; // Foreign
  BRANCH?: string; // Local
  BRANCH_NAME?: string; // Foreign
  CARD_NUMBER?: string; // 247 ATM
  PHONE?: string; // Local
  COMPANY_NAME?: string; // Stock
  TEMPLATE_TYPE?: string;
  SERVICE?: string;
  SERVICE_PACKAGE?: string; // Billing gói
  PROVIDER?: string;
  CUSTOMER_CODE?: string;
  KEY?: string;
}

export const handlerMapListBene = (item: TRANSPROFILE, templateType: string) => {
  const list: PROFILE_BENE[] = [];
  if (item.PROFILE_ID?.length) {
    if (item.TRANSTEMPLATES && item.TRANSTEMPLATES.length) {
      item.TRANSTEMPLATES.forEach((transTemplate) => {
        const profile: PROFILE_BENE = {};
        if (
          transTemplate.TEMPLATE_METAS &&
          Array.isArray(transTemplate.TEMPLATE_METAS) &&
          transTemplate.TEMPLATE_METAS.length &&
          transTemplate.TEMPLATE_TYPE === templateType
        ) {
          // if (transTemplate.TEMPLATE_METAS && transTemplate.TEMPLATE_METAS.length) {
          profile.AVATAR = item.AVATAR;
          profile.NAME = item.NAME;
          profile.PROFILE_ID = item.PROFILE_ID;
          profile.KEY = "";
          const characterGroup: string = nonAccentVietnamese(item.NAME?.toUpperCase());
          let hasMoreThanAscii = characterGroup.charCodeAt(0) > 127 ? true : false;
          if (!hasMoreThanAscii) {
            profile.KEY = characterGroup.charAt(0).toUpperCase();
          }
          transTemplate.TEMPLATE_METAS.forEach((tempMeta) => {
            if (tempMeta.META_KEY === "BEN_NAME") profile.BEN_NAME = tempMeta.META_VALUE;
            if (tempMeta.META_KEY === "ACCOUNT_NUMBER") profile.ACCOUNT_NUMBER = tempMeta.META_VALUE;
            if (tempMeta.META_KEY === "CARD_NUMBER") profile.CARD_NUMBER = tempMeta.META_VALUE;
            if (tempMeta.META_KEY === "BRANCH") profile.BRANCH = tempMeta.META_VALUE;
            if (tempMeta.META_KEY === "BANK_NAME") profile.BANK_NAME = tempMeta.META_VALUE;
            if (tempMeta.META_KEY === "REGION_NAME") profile.REGION_NAME = tempMeta.META_VALUE;
            if (tempMeta.META_KEY === "BRANCH_NAME") profile.BRANCH_NAME = tempMeta.META_VALUE;
            if (tempMeta.META_KEY === "COMPANY_NAME") profile.COMPANY_NAME = tempMeta.META_VALUE;
            if (tempMeta.META_KEY === "PHONE") profile.PHONE = tempMeta.META_VALUE;
            if (tempMeta.META_KEY === "SERVICE") profile.SERVICE = tempMeta.META_VALUE;
            if (tempMeta.META_KEY === "PROVIDER") profile.PROVIDER = tempMeta.META_VALUE;
            if (tempMeta.META_KEY === "SERVICE_PACKAGE") profile.SERVICE_PACKAGE = tempMeta.META_VALUE;
            if (tempMeta.META_KEY === "CUSTOMER_CODE") profile.CUSTOMER_CODE = tempMeta.META_VALUE;
            profile.TEMPLATE_TYPE = transTemplate.TEMPLATE_TYPE;
          });
          list?.push(profile);
        }
      });
    }
  }
  return list;
};

export const handlerListBene = (data?: TRANSPROFILE[], templateType?: string) => {
  let listTemp: PROFILE_BENE[] = [];
  const listBene: PROFILE_BENE[] = [];
  if (data?.length && templateType?.length) {
    data.forEach((item) => {
      listTemp = handlerMapListBene(item, templateType);
      if (listTemp.length) {
        listTemp.forEach((temp) => {
          listBene.push(temp);
          return;
        });
      }
    });
  }
  return listBene;
};

export const getHeaderRight = (type?: string) => {
  switch (type) {
    case Constant.TEMPLATE_TYPE.INTERNAL_TRANSFER:
    case Constant.TEMPLATE_TYPE.INTERBANK_TRANSFER:
    case Constant.TEMPLATE_TYPE.DEPOSIT_TO_STOCK_TRADE_ACCOUNT:
      return i18n.t("BENE_SO_TAI_KHOAN");
    case Constant.TEMPLATE_TYPE.CASH_BY_CODE_TEMPLATE:
    case Constant.TEMPLATE_TYPE.INTERBANK_FAST_TRANSFER:
      return i18n.t("BENE_SO_TAI_KHOAN_SO_THE");
    case Constant.TEMPLATE_TYPE.TOP_UP_TEMPLATE:
      return i18n.t("BENE_SO_DIEN_THOAI_TAI_KHOAN_DICH_VU");
    case Constant.TEMPLATE_TYPE.BILLING_TEMPLATE:
      return i18n.t("BENE_MA_HD_KH_SDT");
    default:
      return i18n.t("BENE_SO_TAI_KHOAN");
  }
};

export const getHeaderLeft = (type?: string) => {
  switch (type) {
    case Constant.TEMPLATE_TYPE.INTERNAL_TRANSFER:
    case Constant.TEMPLATE_TYPE.INTERBANK_TRANSFER:
    case Constant.TEMPLATE_TYPE.INTERBANK_FAST_TRANSFER:
    case Constant.TEMPLATE_TYPE.DEPOSIT_TO_STOCK_TRADE_ACCOUNT:
    case Constant.TEMPLATE_TYPE.CASH_BY_CODE_TEMPLATE:
      return i18n.t("BENE_TAI_KHOAN_THU_HUONG");
    case Constant.TEMPLATE_TYPE.TOP_UP_TEMPLATE:
    case Constant.TEMPLATE_TYPE.BILLING_TEMPLATE:
      return i18n.t("BENE_DICH_VU");
    default:
      return i18n.t("BENE_TAI_KHOAN_THU_HUONG");
  }
};
